import React, { Fragment } from 'react'
import {
  Loader,
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui'
import Timeline from './Timeline'
import LearnMoreLegal from '../../Legal'

import styles from './Macys.css'
import { BespokeInterstitialProps } from '../types'

export const MacysLearnMore = (
  {
    copy
  }: BespokeInterstitialProps
) => (
  <Fragment>
    <style>{
      styles
    }</style>
    {!copy
      ? (<div className="loader"><Loader /></div>)
      : (<div>
        <Typography textToken='text-style/headings/titles/bold/tertiary'>
          {copy.title}
        </Typography>
        <SpacerVertical spaceToken='space/200' />
        <Typography textToken='text-style/text/paragraphs/body/regular'>
          {copy.subtitle}
        </Typography>
        <Timeline copy={copy.timeline} />
        <LearnMoreLegal copy={copy.legal} />
      </div>)
    }
  </Fragment>
)
